let dd = require('ES/lib/dd');
let FullLayout = require('ES/widgets/FullLayout');
let HeadNavbar = require('./HeadNavbar');

module.exports = dd.createClass({
	render(){
		let {Displaylists} = this.props;
		return FullLayout({vertical: true}, [
			{
				height: 52,
				body: HeadNavbar({Displaylists})
			},
			{
				body: this.props.children
			}
		]);
	}
});



// WEBPACK FOOTER //
// ./src/components/layout/StandardLayout.js